import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import BlankState from './BlankState';
import StatusMessages from './StatusMessages';
import PolicyGoodsTable from './PolicyGoodsTable';

import LocalDB from '../utils/localDB';
import { editGood, editRemoveGood } from '../utils/good-utils';

import {
  listCountries,
  listConveyance,
  updateQuote,
  listGoodsSections,
  listGoods
} from './../actions/policy';
import { listCurrencyRates } from '../actions/currencies';

import DateRangePicker from 'react-bootstrap-daterangepicker';
import Select from 'react-select';

import Panel from './Panel';

class EditExpiredPolicies extends Component {
  constructor(props) {
    super(props);

    this.state = {
      policy_details: {
        ...this.props.policy_info
      },
      policy_details_updating: false,
      has_errors: false,
      options: [{ value: true, label: 'Yes' }, { value: false, label: 'No' }],
      selectValue: null,
      show_goods_form: true
    };
  }

  componentWillMount() {
    LocalDB.flush();
  }

  componentDidMount() {
    const {
      listCurrencyRates,
      listCountries,
      listConveyance,
      listGoodsSections
    } = this.props;

    listConveyance();
    listCurrencyRates();
    listCountries();
    listGoodsSections();
  }

  componentWillReceiveProps = nextProps => {
    const { policy_info } = nextProps;

    this.setState({
      policy_details: policy_info || {},
      updated_policy: {
        id: policy_info ? policy_info.id : ''
      }
    });
  };

  onChangeSelect = value => {
    const { updated_policy, policy_details } = this.state;
    const { policy } = this.state.updated_policy;
    console.log(policy);
    this.setState({
      updated_policy: {
        ...updated_policy,
        policy: {
          ...policy,
          is_open_cover: value.value
        }
      },
      policy_details: {
        ...policy_details,
        policy: {
          ...this.state.policy_details.policy,
          is_open_cover: value.value
        }
      }
    });
  };

  handleGoodAddition = e => {
    e.preventDefault();

    const { policy_details } = this.state.policy_details || {};
    console.log(this.state.policy_details);

    let new_goods_list = editGood(this.state.policy_details.policy.quote_goods);

    if (new_goods_list !== false) {
      this.setState({
        policy_details: {
          ...policy_details,
          policy: {
            ...this.state.policy_details.policy,
            quote_goods: new_goods_list
          }
        },
        show_goods_form: false
      });
    }
  };

  removeGood = good => {
    const { policy_details } = this.state;
    const selected_goods = editRemoveGood(
      this.state.policy_details.policy.quote_goods,
      good
    );
    console.log(selected_goods);
    this.setState({
      policy_details: {
        ...policy_details,
        policy: {
          ...this.state.policy_details.policy,
          quote_goods: selected_goods
        }
      }
    });
  };

  onChange = e => {
    const { updated_policy, policy_details } = this.state;
    const { policy } = this.state.updated_policy || {};
    const { name, value } = e.target;

    this.setState({
      updated_policy: {
        ...updated_policy,
        policy: {
          ...policy,
          [name]: value
        }
      },
      policy_details: {
        ...policy_details,
        policy: {
          ...this.state.policy_details.policy,
          [name]: value
        }
      }
    });
  };

  onSubmit = e => {
    e.preventDefault();

    const { policy_details } = this.state;

    this.setState({ policy_details_updating: true });
    let handler = {};
    if (policy_details.hasOwnProperty('id')) {
      handler = this.props.updateQuote(policy_details);
    }
  };

  render() {
    const { policy, currencyRates } = this.props;

    const { policy_details_updating } = this.state;
    console.log(this.state.policy_details);
    let policyICC = this.state.policy_details
      ? this.state.policy_details.institute_cargo_clause
      : null;
    let policyConveyance = this.state.policy_details
      ? this.state.policy_details.conveyance_used
      : null;
    let policyCountryFrom = this.state.policy_details
      ? this.state.policy_details.country_from
      : null;
    let policyDateCreated = this.state.policy_details
      ? this.state.policy_details.date_created
      : null;
    let policyInsuredName =
      this.state.policy_details && this.state.policy_details.insured_data
        ? this.state.policy_details.insured_data.name
        : {};
    let policyInsuredEmail =
      this.state.policy_details && this.state.policy_details.insured_data
        ? this.state.policy_details.insured_data.email
        : null;
    let policyInsuredTIN = this.state.policy_details
      ? this.state.policy_details.tra_pin
      : null;
    let policySumInsured = this.state.policy_details
      ? this.state.policy_details.total_sum_insured
      : null;
    let policyPremium = this.state.policy_details
      ? this.state.policy_details.premium
      : null;
    let policyVAT = this.state.policy_details
      ? this.state.policy_details.total_vat_duty
      : null;
    let policyStartDate = this.state.policy_details
      ? this.state.policy_details.start_date
      : null;
    let policyIsOpenCover = this.state.policy_details
      ? this.state.policy_details.is_open_cover
      : null;
    let policyPolicyNumber = this.state.policy_details
      ? this.state.policy_details.policy_number
      : null;
    let policyEndorsementNumber = this.state.policy_details
      ? this.state.policy_details.endorsement_number
      : null;
    let policyGoods = this.state.policy_details
      ? this.state.policy_details.quote_goods
      : null;
    let policyGoodsSections = this.props.policy
      ? this.props.policy.goodsSections
      : null;

    return (
      <Panel title="Update Policy">
        <BlankState
          data={policy}
          isDataLoading={policy.updateQuoteLoading}
          customMessage="Saving..."
        />

        <form
          id="updateForm"
          className="form-horizontal"
          name="claimForm"
          novalidate
          onSubmit={this.onSubmit}
        >
          {policy && policy.errorUpdateQuote && !policy.updateQuoteLoading ? (
            <StatusMessages
              type="error"
              message={policy.errorMessageUpdateQuote}
            />
          ) : null}
          {policy && policy.success && !policy.updateQuoteLoading ? (
            <StatusMessages type="success" message={policy.success} />
          ) : null}

          <fieldset>
            <legend>Basic Details</legend>
            <div className="form-group has-feedback">
              <label className="control-label col-md-3">
                Currency <span className="text-danger">*</span>
              </label>
              <div className="col-md-9">
                <select
                  disabled
                  id="currency_rate_used"
                  name="currency_rate_used"
                  className="form-control"
                  onChange={this.onChange}
                  required
                >
                  <option value="" disabled>
                    -- Select Currency --
                  </option>

                  {currencyRates &&
                    currencyRates.rates.map(currency => {
                      return (
                        <option key={currency.id} value={currency.id}>
                          {currency.currency_name} -- {currency.currency_code}
                        </option>
                      );
                    })}
                </select>
              </div>
            </div>
            <div className="form-group has-feedback">
              <label className="control-label col-md-3">
                ICC Class <span className="text-danger">*</span>
              </label>
              <div className="col-md-9">
                <select
                  id="institute_cargo_clause"
                  name="institute_cargo_clause"
                  className="form-control"
                  value={policyICC}
                  disabled
                  onChange={this.onChange}
                  required
                >
                  <option value="" disabled>
                    -- Select ICC Class --
                  </option>
                  <option value="ICC-A">ICC-A</option>
                  <option value="ICC-B">ICC-B</option>
                  <option value="ICC-C">ICC-C</option>
                </select>
              </div>
            </div>
            <div className="form-group">
              <label className="control-label col-md-3">
                Conveyance: <span className="text-danger">*</span>
              </label>
              <div className="col-md-9">
                <select
                  disabled
                  id="conveyance_used"
                  className="form-control"
                  name="conveyance_used"
                  value={policyConveyance}
                  onChange={this.onChange}
                  required
                >
                  <option value="" disabled>
                    -- Select Conveyance --
                  </option>
                  {policy &&
                    policy.conveyances.map(conveyance => {
                      return (
                        <option key={conveyance.id} value={conveyance.id}>
                          {conveyance.conveyance_type}
                        </option>
                      );
                    })}
                </select>
              </div>
            </div>
            <div className="form-group has-feedback">
              <label className="control-label col-md-3">
                Country of Export <span className="text-danger">*</span>
              </label>
              <div className="col-md-9">
                <select
                  disabled
                  id="country_from"
                  name="country_from"
                  className="form-control"
                  value={policyCountryFrom}
                  onChange={this.onChange}
                  required
                >
                  <option value="" disabled>
                    -- Select Country From --
                  </option>
                  {policy &&
                    policy.countries.map(country => {
                      return (
                        <option key={country.id} value={country.id}>
                          {country.name}
                        </option>
                      );
                    })}
                </select>
              </div>
            </div>

            <div className="form-group has-feedback">
              <label className="control-label col-md-3">
                Date Created <span className="text-danger">*</span>
              </label>
              <div className="col-md-9">
                <DateRangePicker
                  singleDatePicker
                  locale={{ format: 'YYYY-MM-DD' }}
                  onApply={this.onChange}
                >
                  <input
                    type="text"
                    name="date_created"
                    className={'form-control date-picker-control '}
                    style={{ width: '100%' }}
                    value={policyDateCreated || ''}
                  />
                </DateRangePicker>
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend>Details of Insured</legend>
            <div className="form-group has-feedback">
              <label className="control-label col-md-3">
                Name of Insured <span className="text-danger">*</span>
              </label>
              <div className="col-md-9">
                <input
                  id="proposer_name"
                  type="text"
                  disabled
                  name="proposer_name"
                  className="form-control"
                  value={policyInsuredName || ''}
                  onChange={this.onChange}
                  required
                />
              </div>
            </div>
            <div className="form-group has-feedback">
              <label className="control-label col-md-3">
                Email of Insured <span className="text-danger">*</span>
              </label>
              <div className="col-md-9">
                <input
                  id="insured_data"
                  type="text"
                  disabled
                  name="insured_data.email"
                  className="form-control"
                  value={policyInsuredEmail || ''}
                  onChange={this.onChange}
                  required
                />
              </div>
            </div>
            <div className="form-group has-feedback">
              <label className="control-label col-md-3">TIN</label>
              <div className="col-md-9">
                <input
                  id="tra_pin"
                  type="text"
                  disabled
                  name="tra_pin"
                  className="form-control"
                  value={policyInsuredTIN || ''}
                  onChange={this.onChange}
                />
              </div>
            </div>
          </fieldset>
          <fieldset>
            <legend>Details of Cover</legend>
            <div className="form-group has-feedback">
              <label className="control-label col-md-3">
                Total Sum Insured <span className="text-danger">*</span>
              </label>
              <div className="col-md-9">
                <input
                  id="total_sum_insured"
                  type="text"
                  disabled
                  name="total_sum_insured"
                  className="form-control"
                  value={policySumInsured || ''}
                  onChange={this.onChange}
                  required
                />
              </div>
            </div>
            <div className="form-group has-feedback">
              <label className="control-label col-md-3">
                Premium <span className="text-danger">*</span>
              </label>
              <div className="col-md-9">
                <input
                  id="premium"
                  type="text"
                  disabled
                  name="premium"
                  className="form-control"
                  value={policyPremium || ''}
                  onChange={this.onChange}
                  required
                />
              </div>
            </div>
            <div className="form-group has-feedback">
              <label className="control-label col-md-3">
                VAT <span className="text-danger">*</span>
              </label>
              <div className="col-md-9">
                <input
                  disabled
                  id="total_vat_duty"
                  type="text"
                  name="total_vat_duty"
                  className="form-control"
                  value={policyVAT || ''}
                  onChange={this.onChange}
                  required
                />
              </div>
            </div>
            <div className="form-group has-feedback">
              <label className="control-label col-md-3">
                End Date <span className="text-danger">*</span>
              </label>
              <div className="col-md-9">
                <DateRangePicker
                  id="singleDatePicker"
                  singleDatePicker
                  locale={{ format: 'YYYY-MM-DD' }}
                  onApply={this.onChange}
                >
                  <input
                    type="text"
                    name="start_date"
                    className={'form-control date-picker-control '}
                    style={{ width: '100%' }}
                    value={policyStartDate || ''}
                  />
                </DateRangePicker>
              </div>
            </div>
            <div className="form-group has-feedback">
              <label className="control-label col-md-3">
                Is this an Open Cover <span className="text-danger">*</span>
              </label>
              <div className="col-md-9">
                <Select
                  disabled
                  onChange={this.onChangeSelect}
                  options={this.state.options}
                  value={policyIsOpenCover}
                />
              </div>
            </div>
            <div className="form-group has-feedback">
              <label className="control-label col-md-3">
                Policy Number <span className="text-danger">*</span>
              </label>
              <div className="col-md-9">
                <input
                  disabled
                  id="policy_number"
                  type="text"
                  name="policy_number"
                  className="form-control"
                  value={policyPolicyNumber || ''}
                  onChange={this.onChange}
                  required
                />
              </div>
            </div>
            {policyIsOpenCover !== '' ? (
              <div className="clearfix">
                {policyIsOpenCover === true ? (
                  <div className="form-group has-feedback">
                    <label className="control-label col-md-3">
                      Endorsement Number <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-9">
                      <input
                        disabled
                        id="endorsement_number"
                        type="text"
                        name="endorsement_number"
                        className="form-control"
                        value={policyEndorsementNumber || ''}
                        onChange={this.onChange}
                        required
                      />
                    </div>
                  </div>
                ) : null}
              </div>
            ) : null}
          </fieldset>
          {/* <fieldset>
            <legend>Goods details</legend>
            <div className="form-group">
              <div className="col-sm-offset-0 col-sm-12 col-lg-12">
                <PolicyGoodsTable
                  id="goodsTable"
                  currency_rate={currencyRates ? currencyRates.rates : null}
                  sections_list={policyGoodsSections}
                  show_goods_form={this.state.show_goods_form}
                  selected_goods={policyGoods}
                  goods={policyGoods}
                  addGoodsFn={this.handleGoodAddition}
                  removeGoodsFn={this.removeGood}
                />
              </div>
            </div>
          </fieldset> */}

          <div className="form-end col-md-offset-3 col-md-9">
            <button type="submit" className="btn btn-warning">
              <i className="icon ion-checkmark" />Update Policy
            </button>
          </div>
        </form>
      </Panel>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  policy: state.policy,
  currencyRates: state.currency
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      listCurrencyRates,
      listCountries,
      listConveyance,
      updateQuote,
      listGoodsSections,
      listGoods
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditExpiredPolicies);



// WEBPACK FOOTER //
// ./src/components/EditExpiredPolicies.js